module.exports = __webpack_public_path__ + "img/menu_icon_bill.5e5830ff.svg";